var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudDatabase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    width: 24,
    height: 24,
    color: "#22543d",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-637b8d40f95e86b59c57a2cb-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "roll_brush",
    "data-name": "roll brush"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-637b8d40f95e86b59c57a2cb-1",
    d: "M18.68,12h-1V10.08A5.75,5.75,0,0,0,12,4.33h-.21a5.69,5.69,0,0,0-4.82,3,2.15,2.15,0,0,0-.14.26,6.63,6.63,0,0,0-.56,2.52h0a4.78,4.78,0,0,0-4.8,4.8,1.41,1.41,0,0,0,0,.2,4.8,4.8,0,0,0,4.79,4.59H18.68a3.82,3.82,0,0,0,3.82-3.58,2.17,2.17,0,0,0,0-.26A3.82,3.82,0,0,0,18.68,12Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudDatabase);
export default __webpack_public_path__ + "static/media/cloud-database.d355a11fcd145e65bfdc4b591e71df7d.svg";
export { ForwardRef as ReactComponent };